var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue-aui-multi-select2"},[_c('input',{ref:"input",attrs:{"disabled":_vm.disabled,"type":"hidden"}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }